import React from 'react';
import { LinearGauge } from '@components/UI-Elements/Charts/LinearGauge/LinearGauge';
import { EditOutlined } from '@mui/icons-material';
import { IFormulaToAccount } from '@sp-types/accountTypes';

import { INetExposure } from '@sp-types/netExposureType';
import { formatToPriceInDollars } from '@utils/FormatValue';
import { getNetExposure } from '@utils/exposureUtils';

interface ExposureText {
  name: string;
  desc: string;
  value: string;
}
interface Props {
  formulaId: string;
  accountMaterial?: IFormulaToAccount;
  netExposure: INetExposure;
  convertionMap: Record<string, number>;
  onEdit?: () => void;
}
export const ExposureMonitor: React.FC<Props> = ({
  formulaId,
  accountMaterial,
  netExposure,
  onEdit,
  convertionMap,
}) => {
  const getExposureTexts = (formulaId: string): ExposureText[] => {
    const exposure = netExposure.materialsExposure[formulaId];
    const convert = convertionMap[formulaId];
    return [
      { name: 'Future orders', desc: 'Net value', value: formatToPriceInDollars(exposure.futureOrder * convert) },
      { name: 'Inventory', desc: 'Total value', value: formatToPriceInDollars(exposure.inventorySum * convert) },
      {
        name: 'Financial positions',
        desc: 'Net value',
        value: formatToPriceInDollars(exposure.financialPositions * convert),
      },
    ];
  };

  return formulaId && netExposure?.materialsExposure[formulaId] ? (
    <div className="flex flex-1 flex-col  gap-2 p-4 text-base ">
      {getExposureTexts(formulaId)?.map(({ name, value, desc }, index) => (
        <div className="flex flex-row pb-2 border-b-2 border-b-gray-200 justify-between" key={index}>
          <div className="flex flex-row  flex-1 justify-between">
            <p>{name}</p>
            <span className="flex flex-col justify-between gap-2  w-20">
              <p className="text-sm text-gray-300">{desc}</p>
              <p>{value}</p>
            </span>
          </div>
          {onEdit && (
            <p
              className={`text-blue-600 ${index ? '' : 'cursor-pointer hover:bg-light-blue'} rounded-sm   h-6 w-6 `}
              onClick={index === 0 ? onEdit : undefined}
            >
              {index === 0 ? <EditOutlined /> : <div className="flex flex-1  flex-row  bg-red"></div>}
            </p>
          )}
        </div>
      ))}
      <div className=" flex flex-col flex-1 justify-evenly gap-4">
        <div className="">Exposure monitor</div>
        {accountMaterial && (
          <div>
            <LinearGauge
              riskTolerance={accountMaterial.RiskTolerance}
              currentValue={getNetExposure(netExposure, convertionMap, formulaId)}
            />
          </div>
        )}
      </div>
    </div>
  ) : (
    <ExposureSkeleton />
  );
};

const ExposureSkeleton = () => (
  <div className="flex flex-col gap-3 p-3">
    {[1, 2, 3, 4].map((_, key) => (
      <div className="h-12 w-full bg-gray-100 animate-pulse rounded-xl" key={key}></div>
    ))}
  </div>
);
